//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.Dialogs.TraProKategorieUdalosti.ts						</Name>
//    <Description> Volání Adm dialogů: TraProKategorieUdalosti							</Description>
//    <Author>      FFIALA								</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018			</Copyright>
//    <Created>     2018-11-07                                  </Created>
//  </FileHeader>

namespace Gordic.Adm.Dialogs {

    // TraProKategorieUdalosti
    export function DetailTraProKategorieUdalostiDlg(
        parentContent: GContent,
        opt: {
            /** ktg_evn */
            ktg_evn?: Number | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailTraProKategorieUdalosti', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmTraProKategorieUdalosti#",
            ktg_evn: opt ? opt.ktg_evn : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    // TraProKategorieUdalosti
    export function SeznamTraProKategorieUdalostiDlg(
        parentContent: GContent,
        opt: {
            /** ktg_evn */
            ktg_evn?: Number | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamTraProKategorieUdalosti', {}]

        const options = {
            ID: "AdmTraProKategorieUdalosti#",
            ktg_evn: opt ? opt.ktg_evn : undefined,
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }
}
